import { z } from "zod";
import { InvoiceTemplateSort } from "../invoiceTemplate";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum InvoiceTemplateColumn {
    NAME = "name",
    CUSTOMER = "customer",
    ENTITY = "entity",
    TOTAL = "total",
    INVOICES = "invoices",
    LAST_USED = "lastUsed",
    CREATED = "created",
    CREATED_BY = "createdBy",
    UPDATED = "updated",
    UPDATED_BY = "updatedBy",
    ARCHIVED = "archived",
    ARCHIVED_BY = "archivedBy",
    ACTIONS = "actions",
}

const makeColumnSchema = (id: InvoiceTemplateColumn) =>
    ColumnSchema.extend({ id: z.literal(id) });

export const InvoiceTemplateViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.INVOICE_TEMPLATE),
    // Active column sort. Held on the view so it persists alongside column
    // layout via the workspace-user view cache (no parallel sort state).
    sort: z.nativeEnum(InvoiceTemplateSort).optional(),
    columns: z.array(
        z.discriminatedUnion("id", [
            makeColumnSchema(InvoiceTemplateColumn.NAME),
            makeColumnSchema(InvoiceTemplateColumn.CUSTOMER),
            makeColumnSchema(InvoiceTemplateColumn.ENTITY),
            makeColumnSchema(InvoiceTemplateColumn.TOTAL),
            makeColumnSchema(InvoiceTemplateColumn.INVOICES),
            makeColumnSchema(InvoiceTemplateColumn.LAST_USED),
            makeColumnSchema(InvoiceTemplateColumn.CREATED),
            makeColumnSchema(InvoiceTemplateColumn.CREATED_BY),
            makeColumnSchema(InvoiceTemplateColumn.UPDATED),
            makeColumnSchema(InvoiceTemplateColumn.UPDATED_BY),
            makeColumnSchema(InvoiceTemplateColumn.ARCHIVED),
            makeColumnSchema(InvoiceTemplateColumn.ARCHIVED_BY),
            makeColumnSchema(InvoiceTemplateColumn.ACTIONS),
        ]),
    ),
});

export type InvoiceTemplateView = z.infer<typeof InvoiceTemplateViewSchema>;
